export default __webpack_public_path__ + "static/media/cristi.db13928a.png";